import React, { useState, useEffect } from "react";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import axios from "../axios";
import LoadingBar from "react-top-loading-bar";
import _ from "lodash";
import useCartStore from "../Stores/CartStore"; // تأكد من المسار الصحيح
import { Slide, toast } from "react-toastify";
import ProductDetailsSkeleton from "../Skeltons/ProductSkelton";
import { BiSolidOffer } from "react-icons/bi";

const ProductDetailsPage = () => {
  const { id } = useParams();
  const [progress, setProgress] = useState(0);
  const [selectedOffer, setSelectedOffer] = useState(null);
  const [colorOptions, setColorOptions] = useState([]);
  const [sizeOptions, setSizeOptions] = useState([]);
  const [availableOptions, setAvailableOptions] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [mainImage, setMainImage] = useState(""); // تعريف mainImage وحالته
  const [galleryImages, setGalleryImages] = useState([]); // تعريف galleryImages وحالته
  const [videos, setVideos] = useState([]); // تعريف Videos وحالته

  const addToCart = useCartStore((state) => state.addToCart); // استخدام الدالة من Zustand

  const { data, isLoading, error } = useQuery(["product", id], async () => {
    setProgress(30);
    const response = await axios.get(`/products/${id}`);
    setProgress(100);
    return response.data;
  });

  useEffect(() => {
    if (data) {
      setMainImage(data.main_image); // تعيين الصورة الرئيسية الافتراضية
      const videosArray = JSON.parse(data.videos || "[]");
      setVideos(videosArray);
      // تحويل gallery من نص إلى مصفوفة
      const galleryArray = JSON.parse(data.gallery || "[]");
      setGalleryImages([data.main_image, ...galleryArray]); // إضافة الصورة الرئيسية إلى بداية مجموعة الصور

      const uniqueColors = _.uniqBy(data.options, "color_id").map((option) => ({
        value: option.color_id,
        label: option.color_name,
      }));
      const uniqueSizes = _.uniqBy(data.options, "size_id").map((option) => ({
        value: option.size_id,
        label: option.size_name,
      }));
      setColorOptions(uniqueColors);
      setSizeOptions(uniqueSizes);
    }
  }, [data]);

  useEffect(() => {
    if (selectedOffer) {
      const initialOptions = Array.from(
        { length: selectedOffer.quantity },
        () => ({
          color_id: null,
          size_id: null,
        })
      );
      setSelectedOptions(initialOptions);

      const initialAvailableOptions = Array.from(
        { length: selectedOffer.quantity },
        () => ({
          sizes: getAvailableSizes(null),
          colors: getAvailableColors(null),
        })
      );
      setAvailableOptions(initialAvailableOptions);
    }
  }, [selectedOffer]);

  const getAvailableSizes = (colorId) => {
    return _.uniqBy(
      data.options
        .filter((option) => !colorId || option.color_id === colorId)
        .map((option) => ({
          value: option.size_id,
          label: option.size_name,
          stock: option.stock,
        })),
      "value"
    );
  };

  const getAvailableColors = (sizeId) => {
    return _.uniqBy(
      data.options
        .filter((option) => !sizeId || option.size_id === sizeId)
        .map((option) => ({
          value: option.color_id,
          label: option.color_name,
          stock: option.stock,
        })),
      "value"
    );
  };

  const handleOfferChange = (offerId) => {
    setSelectedOffer(data.offers.find((offer) => offer.id === offerId));
  };

  const handleColorChange = (color, index) => {
    const newOptions = [...selectedOptions];

    // إذا كان نفس اللون مختار مسبقًا، قم بإلغاء التحديد
    if (newOptions[index].color_id === color.value) {
      newOptions[index] = {
        ...newOptions[index],
        color_id: null, // إلغاء التحديد
      };
    } else {
      newOptions[index] = {
        ...newOptions[index],
        color_id: color ? color.value : null, // تحديد اللون
      };
    }

    setSelectedOptions(newOptions);

    const sizes = getAvailableSizes(color ? color.value : null);
    const updatedAvailableOptions = [...availableOptions];
    updatedAvailableOptions[index].sizes = sizes;
    setAvailableOptions(updatedAvailableOptions);
  };

  const handleSizeChange = (size, index) => {
    const newOptions = [...selectedOptions];

    // إذا كان نفس المقاس مختار مسبقًا، قم بإلغاء التحديد
    if (newOptions[index].size_id === size.value) {
      newOptions[index] = {
        ...newOptions[index],
        size_id: null, // إلغاء التحديد
      };
    } else {
      newOptions[index] = {
        ...newOptions[index],
        size_id: size ? size.value : null, // تحديد المقاس
      };
    }

    setSelectedOptions(newOptions);

    const colors = getAvailableColors(size ? size.value : null);
    const updatedAvailableOptions = [...availableOptions];
    updatedAvailableOptions[index].colors = colors;
    setAvailableOptions(updatedAvailableOptions);
  };

  useEffect(() => {
    if (selectedOptions.length > 0) {
      selectedOptions.forEach((option, index) => {
        const sizes = getAvailableSizes(option.color_id);
        const colors = getAvailableColors(option.size_id);
        const updatedAvailableOptions = [...availableOptions];
        updatedAvailableOptions[index] = {
          sizes,
          colors,
        };
        setAvailableOptions(updatedAvailableOptions);
      });
    }
  }, [selectedOptions, data]);

  const addToCartHandler = () => {
    if (
      selectedOffer &&
      selectedOptions.every((option) => option.color_id && option.size_id)
    ) {
      const cartItem = {
        productId: id,
        productName: data.name,
        offerId: selectedOffer.id,
        quantity: selectedOffer.quantity,
        price: selectedOffer.price,
        options: selectedOptions.map((option) => ({
          color: colorOptions.find((c) => c.value === option.color_id),
          size: sizeOptions.find((s) => s.value === option.size_id),
        })),
      };
      addToCart(cartItem);
      toast.success("تم اضافة المنتج الي السلة بنجاح", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Slide,
      });
    } else {
      toast.info("لازم تختار لون ومقاس لكل قطعة", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Slide,
      });
    }
  };

  if (isLoading) return <ProductDetailsSkeleton />; // عرض الـ Skeleton عند التحميل
  if (error) return <p>حدث خطأ: {error.message}</p>;

  return (
    <div className="container mx-auto p-6">
      <LoadingBar
        color="#f11946"
        progress={progress}
        onLoaderFinished={() => setProgress(0)}
      />
      <div className="flex flex-wrap lg:flex-nowrap gap-6 flex-col lg:flex-row">
        {/* الصور */}
        <div className="flex-1">
          <div className="mb-4 flex justify-center">
            <img
              src={`https://api.van-graph.com/storage/${mainImage}`}
              alt={data.name}
              className="w-72 object-cover mb-4 h-96"
              loading="lazy"
            />
          </div>
          <div className="flex flex-wrap gap-2 justify-center">
            {galleryImages.length > 0 ? (
              galleryImages.map((image, index) => (
                <img
                  loading="lazy"
                  key={index}
                  src={`https://api.van-graph.com/storage/${image}`}
                  alt={`Gallery Image ${index + 1}`}
                  className={`w-24 h-24 object-cover cursor-pointer ${
                    mainImage === image ? "border-2 border-blue-500" : ""
                  }`}
                  onClick={() => setMainImage(image)}
                />
              ))
            ) : (
              <p>لا توجد صور في المعرض.</p>
            )}
          </div>
        </div>
        {/* معلومات المنتج */}
        <div className="flex-1">
          <h1 className="text-3xl font-bold mb-4">{data.name}</h1>
          <p className="mb-4">{data.description}</p>

          {/* عرض المعرض */}
          <div className="mt-4">
            <h2 className="text-xl font-bold  mb-3">العروض:</h2>
            <div className="flex flex-wrap flex-col gap-2 mb-4">
              {data.offers.map((offer) => (
                <>
                  <button
                    key={offer.id}
                    onClick={() => handleOfferChange(offer.id)}
                    className={`p-2 rounded-lg flex items-center justify-center font-semibold ${
                      selectedOffer?.id === offer.id
                        ? "bg-blue-500 text-white"
                        : "bg-gray-200"
                    }`}
                  >
                    <BiSolidOffer className="text-3xl  text-red-600 ml-3 " />
                    اشتري {offer.quantity} قطع بـ {offer.price} جنيه
                  </button>
                </>
              ))}
            </div>

            {selectedOffer && (
              <div>
                <p className="mb-4 text-red-500 font-semibold">
                  اختر لون ومقاس كل قطعة داخل العرض
                </p>
                {selectedOptions.map((option, index) => (
                  <div
                    key={index}
                    className="flex flex-col md:flex-row flex-wrap relative justify-around items-center border border-gray-300 my-4 rounded p-2 shadow"
                  >
                    <p className="absolute -top-3 bg-white right-4">
                      القطعة {index + 1}
                    </p>
                    <div className="flex flex-col">
                      <div className="flex flex-wrap gap-2 mb-2">
                        {availableOptions[index]?.colors.map((color) => {
                          const isOutOfStock =
                            data.options.find(
                              (opt) =>
                                opt.color_id === color.value &&
                                opt.size_id === option.size_id
                            )?.stock == 0;

                          return (
                            <button
                              key={color.value}
                              onClick={() =>
                                !isOutOfStock && handleColorChange(color, index)
                              }
                              className={`p-2 rounded-lg ${
                                option.color_id === color.value
                                  ? "bg-blue-500 text-white"
                                  : "bg-gray-200"
                              } ${
                                isOutOfStock
                                  ? "cursor-not-allowed opacity-50"
                                  : ""
                              }`}
                              disabled={isOutOfStock}
                            >
                              {color.label} {isOutOfStock && "(غير متوفر)"}
                            </button>
                          );
                        })}
                      </div>
                    </div>
                    <div className="flex flex-col">
                      <div className="flex flex-wrap gap-2">
                        {availableOptions[index]?.sizes.map((size) => {
                          const isOutOfStock =
                            data.options.find(
                              (opt) =>
                                opt.size_id === size.value &&
                                opt.color_id === option.color_id
                            )?.stock == 0;

                          return (
                            <button
                              key={size.value}
                              onClick={() =>
                                !isOutOfStock && handleSizeChange(size, index)
                              }
                              className={`p-2 rounded-lg ${
                                option.size_id === size.value
                                  ? "bg-blue-500 text-white"
                                  : "bg-gray-200"
                              } ${
                                isOutOfStock
                                  ? "cursor-not-allowed opacity-50"
                                  : ""
                              }`}
                              disabled={isOutOfStock}
                            >
                              {size.label} {isOutOfStock && "(غير متوفر)"}
                            </button>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                ))}
                <button
                  onClick={addToCartHandler}
                  className="bg-green-500 text-white p-2 rounded-lg mt-4 block w-full"
                >
                  اضف إلى السلة
                </button>
              </div>
            )}
            {videos.map((video, index) => (
              <div className="mt-4">
                <video controls key={index}>
                  <source
                    src={`https://api.van-graph.com/storage/${video}`}
                    type="video/mp4"
                  />
                  Your browser does not support the video tag.
                </video>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetailsPage;
